import * as focusTrap from 'focus-trap';

const searchOverlay = document.querySelector( '.search-overlay' );
const searchOverlayToggles = document.querySelectorAll( '[data-open-search]' );
const searchBackdrop = document.querySelector( '.search-backdrop' );
let trap = focusTrap.createFocusTrap( searchOverlay, {
  onActivate: () => {
    searchOverlay.classList.toggle( 'open' );

    if (searchOverlay.classList.contains( 'open' )) {
      searchOverlay.querySelector( 'input[type="text"]' ).focus();
    } else {
      searchOverlay.focus();
    }
  },
  onDeactivate: () => {
    searchOverlay.classList.toggle( 'open' );
  }
} );

function initSearchOverlay() {

  if (searchOverlayToggles.length) {
    [...searchOverlayToggles].forEach( (element) => {
      element.addEventListener( 'click', (event) => {
        event.preventDefault();

        trap.active ? trap.deactivate() : trap.activate();
      } );
    } );
  }

  searchBackdrop.addEventListener( 'click', () => {
    trap.deactivate();
  } );
}

export default {
  init() {
    initSearchOverlay();
  },
};